<template>
  <BaseTemplate>
    <div class="confirm-buy-point">
      <Title eng="BUY POINTS" jpn="BUY POINTS" />
      <div class="area_box">
        <div class="point-value-area">
          <div class="title">Number confirmation URL</div>
          <ShadowBox class="shadow-box point" opacity="_60">
            <span><a :href="url" target="_blank">{{url}}</a></span>
          </ShadowBox>
          <span class="text">Please make payment at a convenience store using the information above.</span>
        </div>
      </div>
      <div class="button-area">
        <BlackGradationButton
          class="square-button"
          text="HOME"
          @handleSquareBtnClick="goTop"
        />
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title.vue';
import axios from 'axios';

export default {
  name: 'ConfirmCombini',

  components: {
    BaseTemplate,
    BlackGradationButton,
    Title,
  },

  data: () => ({
    url: '',
  }),

  created() {
    const axiosCtrl = axios.create();
    axiosCtrl.get('/api/user/point/combini_number').then(
      (res) => {
        this.url = res.data.url;
      },
    ).catch(
      () => {
        window.alert('Unable to connect to payment company. \nPlease try again later.');
      },
    );
  },

  methods: {
    goTop() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-buy-point{
  width: 100%;
  max-width: 1800px;
  min-height: 100%;
  padding: 30px 24px 25px 24px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  .area_box {
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
  }
  .confirm-buy-point-title{
    font-family: $notoSerif;
    font-size: 30px;
    font-weight: 700;
  }
  .point-value-area{
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 60px;
      margin-top: 5px;
      border-radius: 6px;
      font-family: $notoSerif;
      font-size: 30px;
      font-weight: 700;
      &.point{
        color: $black;
        margin-bottom: 10px;
      }
    }
    .text{
      display: inline-block;
      margin-top: 5px;
      font-family: $notoSans;
      font-size: 16px;
      font-weight: 500;
      line-height: 29px;
    }
  }
  .select-payment{
    margin-top: 10px;
  }
  .confirm.text{
    display: inline-block;
    margin-top: 19px;
    font-family: $notoSans;
    font-size: 18px;
  }
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    .square-button{
      width: 240px;
      height: 50px;
      & + .square-button{
        margin-left: 30px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .confirm-buy-point {
    padding: 30px 10px 25px 10px;
  }
}
</style>
